import { render, staticRenderFns } from "./merchantroleslist.vue?vue&type=template&id=dc97aa06&scoped=true"
import script from "./merchantroleslist.vue?vue&type=script&lang=js"
export * from "./merchantroleslist.vue?vue&type=script&lang=js"
import style0 from "./merchantroleslist.vue?vue&type=style&index=0&id=dc97aa06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc97aa06",
  null
  
)

export default component.exports